<button
  nz-button
  nz-dropdown
  [class.disabled]="disabled"
  [ngClass]="btnStatusClass"
  [nzDropdownMenu]="statusMarkerMenu"
  [nzType]="'default'">
  <ui-icon
    class="sh-status-icon"
    [key]="icon"></ui-icon>

  <ng-container>{{ label | transloco }}</ng-container>

  <ui-icon
    *ngIf="!disabled"
    [key]="'chevron-down'"></ui-icon>
</button>

<nz-dropdown-menu #statusMarkerMenu="nzDropdownMenu">
  <ul
    nz-menu
    *ngIf="!disabled">
    <ng-container *ngFor="let menuItem of menuItems">
      <li
        nz-menu-item
        *ngIf="!menuItem.divider && menuItem.labelCode"
        [ngClass]="{ 'menu-item-selectable': menuItem.selectable && !menuItem.selected, 'menu-item-selected': menuItem.selected }"
        [nzDisabled]="!!menuItem.disabled"
        (click)="menuItemSelected(menuItem)">
        <ui-icon
          *ngIf="menuItem.selected"
          [key]="'check'"></ui-icon>
        {{ menuItem.labelCode | transloco }}
        <span
          class="menu-item-suffix"
          *ngIf="menuItem.suffixCode"
          >{{ menuItem.suffixCode | transloco }}</span
        >
      </li>
      <li
        nz-menu-divider
        *ngIf="menuItem.divider"></li>
    </ng-container>
  </ul>
</nz-dropdown-menu>
